import "./index.scss";
import "@styles/Theme.scss";
import "antd/dist/antd.css";
import {Provider} from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";
import {store} from "@store/root";
import AppRoutes from "./routes/AppRoutes";
import {ConfigProvider, Spin} from "antd";
import {LoadingOutlined} from '@ant-design/icons';
import {HelmetProvider} from 'react-helmet-async';
import {WindowSizeProvider} from "@components/window-size-provider";
import BarcodeReadProvider from "src/components/barcode-read-provider";
import TopnavSearchDropdown from "./components/topnav-search-dropdown/TopnavSearchDropdown";

// wp components map
const components: any = [
    { divId: 'acf/new-releases', component: AppRoutes },
    { divId: 'acf/access-tokens', component: AppRoutes },
    { divId: 'acf/my-collection', component: AppRoutes },
    { divId: 'acf/weekly-movers', component: AppRoutes },
    { divId: 'acf/daily-hot', component: AppRoutes },
    { divId: 'acf/daily-shakers', component: AppRoutes },
    { divId: 'acf/collector-content', component: AppRoutes },
    { divId: 'acf/collector-content-search', component: AppRoutes },
    { divId: 'acf/collector-content-view-all', component: AppRoutes },
    { divId: 'acf/weekly-top-ten', component: AppRoutes },
    { divId: 'acf/post-single', component: AppRoutes },
    { divId: 'acf/post-archive', component: AppRoutes },
    { divId: 'acf/page-search', component: AppRoutes },
    { divId: 'acf/page-partner-portal', component: AppRoutes },
    { divId: 'acf/post-custom-template', component: AppRoutes },
    { divId: 'acf/page-custom-template', component: AppRoutes },
    { divId: 'root', component: AppRoutes },
    { divId: 'header-search-overlay', component: TopnavSearchDropdown },
];

Spin.setDefaultIndicator(<LoadingOutlined className="font-24" spin />);

components.forEach(item => {
    const target = document.getElementById(item.divId);

    if (target) {
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <ConfigProvider>
                        <HelmetProvider>
                            <BrowserRouter>
                                <WindowSizeProvider>
                                    <BarcodeReadProvider>
                                        <item.component/>
                                    </BarcodeReadProvider>
                                </WindowSizeProvider>
                            </BrowserRouter>
                        </HelmetProvider>
                    </ConfigProvider>
                </Provider>
            </React.StrictMode>,
            target
        );
    }
});

//Turn off chrome scroll auto remember
// eslint-disable-next-line  no-restricted-globals
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
